/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { InviteResponseStatus } from './inviteResponseStatus';

export type BookingInviteResponseStatus = InviteResponseStatus | null;
